import { Component, OnInit } from '@angular/core';
import { IOTPdata, IUser, IUserEmail } from 'src/app/models/auth.models';
import { AuthService } from 'src/app/services/auth.service';
import { userType } from 'src/app/constants/global-constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  otpData:IOTPdata;
  user:IUser;
  isLoggedInUserMum: boolean;

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
    this.isLoggedInUserMum = this.authService.user?.userType==userType.MUM ? true : false;
  }

  logout() {
    this.authService.logout();
  }

  setOtpData(event:IOTPdata){
    console.log("OTP Data",event);
    this.otpData = event
  }


  setEmail(event:IUser){
    console.log("Forgot Password EMail ",this.user);
    this.user = event;
  }



}
